/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {sendDownloadLink} from '../api'

export const useMutationSendDownloadLink = createReactQueryMutationHook('sendDownloadLink', sendDownloadLink)
